<template>
  <section class="webinar-stages" :class="{'is-small-device': isSmallDevice}">
    <v-container>
      <div class="row">
        <div class="col-12">
          <rwl-heading h="2"
                       align="center"
                       class="webinar-stages__title"
                       v-html="$t('webinars.stages_title')"></rwl-heading>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-8 offset-sm-2">
          <div class="webinar-stages__description" v-html="$t('webinars.stages_description')"></div>
        </div>
      </div>

      <div>
        <ul class="list" v-html="$t('webinars.stages_description_list')"></ul>
      </div>

      <div class="row">
        <div class="col-12 col-sm-8 offset-sm-2">
          <p class="webinar-stages__description" v-html="$t('webinars.stages_description_2')"></p>
        </div>
      </div>
      <div class="row no-gutters position-relative">
        <stages-item
          :title="$t('webinars.stages_item_1_title')"
          color="#a2d100"
          class="col-12 col-sm-4"
          @click="goTo(1)"
          :decoration="DecorationTriangle"
          :icon="IconProfile"
        >
          <template #image>
            <img :src="`${PUBLIC_PATH}images/stages_experts.jpg`">
          </template>
          <template #description >
            <div v-html="$t('webinars.stages_item_1_description')"></div>
          </template>
        </stages-item>
        <stages-item
          :title="$t('webinars.stages_item_2_title')"
          color="#00baff"
          class="col-12 col-sm-4"
          @click="goTo(2)"
          :decoration="DecorationTriangle"
          :icon="IconSeeBig"
        >
          <template #image>
            <img :src="`${PUBLIC_PATH}images/stages_expierence.jpg`">
          </template>
          <template #description >
            <div v-html="$t('webinars.stages_item_2_description')"></div>
          </template>
        </stages-item>
        <stages-item
          :title="$t('webinars.stages_item_3_title')"
          color="#1c5188"
          class="col-12 col-sm-4"
          @click="goTo(3)"
          :decoration="DecorationTriangle"
          :icon="IconInfo"
        >
          <template #image>
            <img :src="`${PUBLIC_PATH}images/stages_info.jpg`">
          </template>
          <template #description>
            <div v-html="$t('webinars.stages_item_3_description')"></div>
          </template>
        </stages-item>
        <stages-tabs :show="stagesTabsShow" @close="hideStages" :active-tab="activeTab"
                     @goTo="goTo"></stages-tabs>
      </div>
    </v-container>

  </section>
</template>

<script>
  import VContainer from "./ui/VContainer.vue";
  import { RwlHeading } from "@rawlplug/rawlplug-design-components-library"
  import IconClose from "./ui/IconClose.svg";
  import StagesItem from "./stages/StagesItem";
  import { IconProfile, IconInfo, IconSeeBig, DecorationTriangle } from "../components/index";

  const smallDeviceCheck = (mq, vm) => vm.isSmallDevice = mq.matches;

  export default {
    name: "WebinarStages",
    data() {
      return {
        content: {},
        tabHeight: 'auto',
        activeTab: 1,
        stagesTabsShow: false,
        IconProfile,
        IconInfo,
        IconSeeBig,
        DecorationTriangle,
        isSmallDevice: false,
        PUBLIC_PATH: process.env.VUE_APP_ASSETS_PATH
      }
    },
    components: {
      VContainer,
      RwlHeading,
      StagesItem,
    },
    created() {
      const mql = window.matchMedia('(max-width: 767.98px)');

      mql.addListener((mq) => smallDeviceCheck(mq, this))
      smallDeviceCheck(mql, this)
    },
    methods: {
      goTo(tabId) {
        if (!this.stagesTabsShow) this.showStages();
        this.activeTab = tabId;
      },
      showStages() {
        this.stagesTabsShow = true;
        document.body.classList.add('is-stages-tabs-open');
      },
      hideStages() {
        this.stagesTabsShow = false;
        document.body.classList.remove('is-stages-tabs-open');
      },
    }
  }
</script>

<style lang="scss">
  @media (max-width: $breakpoint-sm-max) {
    body.is-stages-tabs-open {
      overflow: hidden;
    }
  }

  .webinar-stages {
    ul.list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin: 0;
      padding: 0;
      margin-bottom: $spacing-5;
      font-size: $font-size-rwl-headline-6;

      li {
        padding: 0;
        list-style-type: none;
        position: relative;
        padding-left: 20px;
        margin-bottom: $spacing-5;

        &::before {
          content: "";
          position: absolute;
          width: 10px;
          height: 10px;
          background-color: $color-rwl-cyan-100;
          display: inline-block;
          border-radius: 50%;
          left: 0px;
          top: 10px;
        }
      }
    }
  }

  .stages-experts {
    .stages-experts__list {
      margin: 1em 0;
    }
  }


  @media all and (min-width: $breakpoint-sm-min){
    .webinar-stages {
      ul.list {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .webinar-stages {
    background: url('#{$assetsPath}images/training_background.jpg');
    background-size: cover;
    background-position: center;
    padding: $section-padding;

    .webinar-stages__title.rwl-heading {
      display: block;
      margin-bottom: $spacing-7;
    }

    &__description {
      text-align: left;
      padding: 0;
      margin-bottom: $spacing-6;
      line-height: $line-height-base;
    }
  }

  @media (min-width: $breakpoint-md-min) {

    .webinar-stages {
      height: auto;
      min-height: 950px;
      transition: min-height 300ms ease-in-out;
      overflow: hidden;
    }
    .is-stages-tabs-open .webinar-stages {
      min-height: 1040px;
    }
  }

  .position-relative {
    position: relative;
  }
</style>
